import { useState, useEffect } from 'react';
import { LEAVE_TYPES, countWorkDays, formatDate, isWorkDay } from '../constants';
import { api } from '../api';

export default function LeaveModal({ onClose, onSaved, initialFrom, initialTo }) {
  const [form, setForm] = useState({
    date_from: initialFrom || '',
    date_to: initialTo || '',
    type: 'vacation',
    note: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [workDays, setWorkDays] = useState(0);

  useEffect(() => {
    if (form.date_from && form.date_to && form.date_from <= form.date_to) {
      setWorkDays(countWorkDays(form.date_from, form.date_to));
    } else {
      setWorkDays(0);
    }
  }, [form.date_from, form.date_to]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.date_from || !form.date_to) return setError('Podaj daty urlopu');
    if (form.date_from > form.date_to) return setError('Data końcowa musi być po dacie początkowej');
    if (workDays === 0) return setError('Wybrany zakres nie zawiera dni roboczych');
    setLoading(true);
    setError('');
    try {
      const result = await api.createLeave(form);
      onSaved(result);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const update = (k, v) => setForm(p => ({ ...p, [k]: v }));

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <span className="modal-title">Nowy wniosek urlopowy</span>
          <button className="btn btn-ghost" onClick={onClose} style={{ fontSize: 20, padding: '4px 8px' }}>×</button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {error && <div className="alert alert-error">{error}</div>}

            <div className="form-group">
              <label className="form-label">Typ urlopu</label>
              <select className="form-input" value={form.type} onChange={e => update('type', e.target.value)}>
                {Object.entries(LEAVE_TYPES).map(([k, v]) => (
                  <option key={k} value={k}>{v.label}</option>
                ))}
              </select>
            </div>

            <div className="date-range-row">
              <div className="form-group">
                <label className="form-label">Data od</label>
                <input className="form-input" type="date" required value={form.date_from} onChange={e => update('date_from', e.target.value)} />
              </div>
              <div className="form-group">
                <label className="form-label">Data do</label>
                <input className="form-input" type="date" required value={form.date_to} min={form.date_from} onChange={e => update('date_to', e.target.value)} />
              </div>
            </div>

            {workDays > 0 && (
              <div className="days-count-box" style={{ marginBottom: 16 }}>
                📅 {workDays} {workDays === 1 ? 'dzień roboczy' : workDays < 5 ? 'dni robocze' : 'dni roboczych'}
                <span style={{ fontWeight: 400, color: 'var(--text3)', fontSize: 13, marginLeft: 8 }}>
                  ({formatDate(form.date_from)} – {formatDate(form.date_to)})
                </span>
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Uwagi (opcjonalnie)</label>
              <textarea className="form-input" rows={3} value={form.note} onChange={e => update('note', e.target.value)} placeholder="Np. wyjazd służbowy, powód urlopu..." style={{ resize: 'vertical' }} />
            </div>

            <div className="alert alert-warning" style={{ margin: 0 }}>
              Po zapisaniu wniosek trafi do managera. Otrzymasz email z decyzją.
            </div>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-outline" onClick={onClose}>Anuluj</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Zapisywanie...' : 'Złóż wniosek'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
